module.exports = __webpack_public_path__ + "static/media/C1.1bc0edab.png";